import { __exports as u } from "./index107.js";
import { __require as m } from "./index108.js";
import { __require as _ } from "./index109.js";
import { __require as x } from "./index110.js";
import { __require as b } from "./index111.js";
import { __require as q } from "./index112.js";
import { __require as j } from "./index113.js";
var c;
function D() {
  if (c) return u;
  c = 1;
  var f = u && u.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  };
  Object.defineProperty(u, "__esModule", { value: !0 }), u.Facade = void 0;
  var d = f(m()), a = _(), h = f(x()), v = f(b()), p = f(q()), y = f(j());
  function o(r, e) {
    e = e || {}, this.raw = a.clone(r), "clone" in e || (e.clone = !0), e.clone && (r = a.clone(r)), "traverse" in e || (e.traverse = !0), "timestamp" in r ? r.timestamp = v.default(r.timestamp) : r.timestamp = /* @__PURE__ */ new Date(), e.traverse && y.default(r), this.opts = e, this.obj = r;
  }
  u.Facade = o;
  var i = o.prototype;
  i.proxy = function(r) {
    var e = r.split(".");
    r = e.shift();
    var t = this[r] || this.obj[r];
    return t && (typeof t == "function" && (t = t.call(this) || {}), e.length === 0 ? this.opts.clone ? l(t) : t : (t = p.default(t, e.join(".")), this.opts.clone ? l(t) : t));
  }, i.field = function(r) {
    var e = this.obj[r];
    return this.opts.clone ? l(e) : e;
  }, o.proxy = function(r) {
    return function() {
      return this.proxy(r);
    };
  }, o.field = function(r) {
    return function() {
      return this.field(r);
    };
  }, o.multi = function(r) {
    return function() {
      var e = this.proxy(r + "s");
      if (Array.isArray(e))
        return e;
      var t = this.proxy(r);
      return t && (t = [this.opts.clone ? a.clone(t) : t]), t || [];
    };
  }, o.one = function(r) {
    return function() {
      var e = this.proxy(r);
      if (e)
        return e;
      var t = this.proxy(r + "s");
      if (Array.isArray(t))
        return t[0];
    };
  }, i.json = function() {
    var r = this.opts.clone ? a.clone(this.obj) : this.obj;
    return this.type && (r.type = this.type()), r;
  }, i.rawEvent = function() {
    return this.raw;
  }, i.options = function(r) {
    var e = this.obj.options || this.obj.context || {}, t = this.opts.clone ? a.clone(e) : e;
    if (!r)
      return t;
    if (this.enabled(r)) {
      var n = this.integrations(), s = n[r] || p.default(n, r);
      return typeof s != "object" && (s = p.default(this.options(), r)), typeof s == "object" ? s : {};
    }
  }, i.context = i.options, i.enabled = function(r) {
    var e = this.proxy("options.providers.all");
    typeof e != "boolean" && (e = this.proxy("options.all")), typeof e != "boolean" && (e = this.proxy("integrations.all")), typeof e != "boolean" && (e = !0);
    var t = e && h.default(r), n = this.integrations();
    if (n.providers && n.providers.hasOwnProperty(r) && (t = n.providers[r]), n.hasOwnProperty(r)) {
      var s = n[r];
      typeof s == "boolean" ? t = s : t = !0;
    }
    return !!t;
  }, i.integrations = function() {
    return this.obj.integrations || this.proxy("options.providers") || this.options();
  }, i.active = function() {
    var r = this.proxy("options.active");
    return r == null && (r = !0), r;
  }, i.anonymousId = function() {
    return this.field("anonymousId") || this.field("sessionId");
  }, i.sessionId = i.anonymousId, i.groupId = o.proxy("options.groupId"), i.traits = function(r) {
    var e = this.proxy("options.traits") || {}, t = this.userId();
    r = r || {}, t && (e.id = t);
    for (var n in r)
      if (Object.prototype.hasOwnProperty.call(r, n)) {
        var s = this[n] == null ? this.proxy("options.traits." + n) : this[n]();
        if (s == null)
          continue;
        e[r[n]] = s, delete e[n];
      }
    return e;
  }, i.library = function() {
    var r = this.proxy("options.library");
    return r ? typeof r == "string" ? { name: r, version: null } : r : { name: "unknown", version: null };
  }, i.device = function() {
    var r = this.proxy("context.device");
    (typeof r != "object" || r === null) && (r = {});
    var e = this.library().name;
    return r.type || (e.indexOf("ios") > -1 && (r.type = "ios"), e.indexOf("android") > -1 && (r.type = "android")), r;
  }, i.userAgent = o.proxy("context.userAgent"), i.timezone = o.proxy("context.timezone"), i.timestamp = o.field("timestamp"), i.channel = o.field("channel"), i.ip = o.proxy("context.ip"), i.userId = o.field("userId"), d.default(i);
  function l(r) {
    return a.clone(r);
  }
  return u;
}
export {
  D as __require
};
//# sourceMappingURL=index88.js.map
